import { Component } from '@angular/core';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { UserGroupService } from '../crud-service';
import { UserGroupCrudIndex } from './crud-index';

@Component({
  selector: 'app-user-group-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [UserGroupService],
})
export class UserGroupIndexComponent extends UserGroupCrudIndex {
  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Nome',
      name: 'name',
      value: '',
    },
  ];
}
